import { gql } from "@apollo/client";

export const deleteRemoteAssetsMutation = gql`
    mutation deleteRemoteAssets($ids: [ID!]!) {
        deleteRemoteAssets(input: { ids: $ids }) {
            successIds
            failedIds
        }
    }
`;
